module.exports = __webpack_public_path__ + "img/ciia-2022.0d5f2512.jpg";